import React from 'react';

import { addModal } from 'core/notifications'

import i18n from 'i18next';

import ReportActivityModal from '../components/reportActivityModal';

export default async ({ id }) => addModal({
  title: i18n.t('report-an-issue'),
  component: <ReportActivityModal id={id} />,
  hasCloseButton: true,
});
